// P1 Supporting scores hierarchy (5 bands, compact). Extracted verbatim
// from AuditPreview.jsx (W2b). Caller supplies the pre-filtered array.
import BlackRockBand from "../BlackRockBand";

export default function PreviewSupportingScores({ supportingScores }) {
  if (!supportingScores || supportingScores.length === 0) return null;
  return (
    <div className="sf-card" style={{ marginBottom: 28 }} data-testid="preview-supporting-scores-card">
      <div className="sf-eyebrow" style={{ marginBottom: 6 }}>The 5 supporting metrics behind your Business Health score</div>
      <p className="sf-muted-text" style={{ fontSize: 13, lineHeight: 1.55, marginBottom: 16, maxWidth: 660 }}>
        Your Business Health score is made of these 5 systems. Here's how each one is performing.
      </p>
      {supportingScores.map((s) => (
        <BlackRockBand
          key={s.id}
          score={s.block.score}
          label={s.block.label}
          bandId={s.block.band}
          explanation={s.block.explanation}
          metricLabel={s.metricLabel}
          size="supporting"
          testId={`preview-${s.id}`}
        />
      ))}
    </div>
  );
}
